// extracted by mini-css-extract-plugin
export default {"Alert":"Alert_Alert__jAM62","Alert__inner":"Alert_Alert__inner__HwgYL","Alert__text":"Alert_Alert__text__w6Tdz","Alert__icon":"Alert_Alert__icon__nbh85"};